// GenToken/solanaConfig.js

/**
 * Get Solana cluster API URL based on network name
 * @param {string} network Network name (devnet, testnet, mainnet-beta)
 * @returns {string} Solana cluster API URL
 */
export const getClusterApiUrl = (network) => {
    switch (network) {
      case 'mainnet-beta':
        return 'https://api.mainnet-beta.solana.com';
      case 'testnet':
        return 'https://api.testnet.solana.com';
      case 'devnet':
      default:
        return 'https://api.devnet.solana.com';
    }
  };
  
  /**
   * Get displayable network name based on network identifier
   * @param {string} network Network identifier
   * @param {string} language Language code ('KR' or 'EN')
   * @returns {string} Human-readable network name
   */
  export const displayNetworkName = (network, language = 'EN') => {
    if (language === 'KR') {
      switch (network) {
        case 'mainnet-beta':
          return '메인넷 베타 (실제 네트워크)';
        case 'testnet':
          return '테스트넷 (테스트 네트워크)';
        case 'devnet':
        default:
          return '개발넷 (개발자 네트워크)';
      }
    } else {
      switch (network) {
        case 'mainnet-beta':
          return 'Mainnet Beta (Production)';
        case 'testnet':
          return 'Testnet (Test Network)';
        case 'devnet':
        default:
          return 'Devnet (Development Network)';
      }
    }
  };
  
  /**
   * Get network explorer URL
   * @param {string} network Network name
   * @returns {string} Solana Explorer base URL for the network
   */
  export const getExplorerUrl = (network) => {
    return `https://explorer.solana.com${network !== 'mainnet-beta' ? `?cluster=${network}` : ''}`;
  };
  
  /**
   * Get token fee estimate in SOL based on network
   * @param {string} network Network name
   * @returns {number} Estimated fee in SOL
   */
  export const getTokenCreationFeeEstimate = (network) => {
    switch (network) {
      case 'mainnet-beta':
        return 0.005; // Higher for mainnet
      case 'testnet':
        return 0.002; // Lower for testnet
      case 'devnet':
      default:
        return 0.001; // Lowest for devnet
    }
  };
  
  /**
   * Get minimum SOL balance required for token creation
   * @param {string} network Network name
   * @returns {number} Minimum SOL balance required
   */
  export const getMinimumSolBalance = (network) => {
    switch (network) {
      case 'mainnet-beta':
        return 0.02; // Higher for mainnet
      case 'testnet':
      case 'devnet':
      default:
        return 0.01; // Lower for test networks
    }
  };